"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeInfoRpcLocal = exports.NODE_INFO_RPC_SERVICE_ID = void 0;
const NetworkRpc_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc");
exports.NODE_INFO_RPC_SERVICE_ID = 'system/node-info-rpc';
class NodeInfoRpcLocal {
    stack;
    rpcCommunicator;
    constructor(stack, rpcCommunicator) {
        this.stack = stack;
        this.rpcCommunicator = rpcCommunicator;
        this.registerDefaultServerMethods();
    }
    registerDefaultServerMethods() {
        this.rpcCommunicator.registerRpcMethod(NetworkRpc_1.NodeInfoRequest, NetworkRpc_1.NodeInfoResponse, 'getInfo', () => this.getInfo());
    }
    async getInfo() {
        return this.stack.createNodeInfo();
    }
}
exports.NodeInfoRpcLocal = NodeInfoRpcLocal;
//# sourceMappingURL=NodeInfoRpcLocal.js.map